import React, { Component } from "react";
import "./Skills.css";
import SoftwareSkill from "../../components/softwareSkills/SoftwareSkill";
import { skills } from "../../portfolio";
import { Fade } from "react-reveal";

class SkillSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSkillIndex: 0
    };
  }

  render() {
    
    return (
      <div className="skills-container">
        {/* Tab Navigation */}
        <div className="skills-tabs">
          {skills.data.map((skill, i) => (
            <button
              key={i}
              onClick={() => this.setState({ activeSkillIndex: i })}
              className={`skill-tab ${this.state.activeSkillIndex === i ? 'active' : ''}`}
              style={{
                background: this.state.activeSkillIndex === i ? '#10b981' : '#374151',
                color: 'white'
              }}
            >
              <span className="skill-tab-icon">
                {i === 0 ? '💻' : i === 1 ? '📊' : '⚙️'}
              </span>
              <span>{skill.title}</span>
            </button>
          ))}
        </div>

        {/* Active Skill Content */}
        <div className="skills-content-card" style={{ backgroundColor: '#1f2937' }}>
          <Fade key={this.state.activeSkillIndex} duration={800}>
            <div>
              {/* Header */}
              <div className="skills-header-section">
                <div className="skills-icon-container">
                  <span className="skills-main-icon">
                    {this.state.activeSkillIndex === 0 ? '💻' : 
                     this.state.activeSkillIndex === 1 ? '📊' : '⚙️'}
                  </span>
                </div>
                <h1 className="skills-title" style={{ color: 'white' }}>
                  {skills.data[this.state.activeSkillIndex].title}
                </h1>
              </div>

              {/* Content Grid */}
              <div className="skills-grid">
                {/* Core Skills */}
                <div className="skills-section">
                  <div className="skills-section-header">
                    <div className="section-indicator"></div>
                    <h3 className="section-title">Core Skills</h3>
                  </div>
                  
                  <div className="core-skills-list">
                    {skills.data[this.state.activeSkillIndex].skills.map((skillSentence, i) => (
                      <div key={i} className="skill-item">
                        <div className="skill-bullet"></div>
                        <p className="skill-text" style={{ color: '#d1d5db' }}>
                          {skillSentence}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Technologies */}
                <div className="skills-section">
                  <div className="skills-section-header">
                    <div className="section-indicator"></div>
                    <h3 className="section-title">Technologies & Tools</h3>
                  </div>
                  
                  <div className="technologies-grid">
                    <SoftwareSkill logos={skills.data[this.state.activeSkillIndex].softwareSkills} />
                  </div>
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    );
  }
}

export default SkillSection;